import React, { lazy } from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";

const CarriersList = lazy(() => import("../../container/pages/carriers/index"));
const NewCarrier = lazy(() => import("../../container/pages/carriers/new"));
const EditCarrier = lazy(() => import("../../container/pages/carriers/edit"));

function CarriersRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/edit/:id`} component={EditCarrier} />
      <Route path={`${path}/new`} component={NewCarrier} />
      <Route path={`${path}`} component={CarriersList} />
    </Switch>
  );
}

export default CarriersRoute;
